import { isNullOrUndefined } from '@as-react/common-utils';
import { all, call, fork, getContext, put, select, delay, takeLatest, takeEvery } from 'redux-saga/effects';
import deliveryPromiseApi from '../../../api/DeliveryPromiseAPI';
import { ProductGroupActionTypes, ProductActionTypes, ProductRecentlyViewedActionTypes, ProductGroupFredhopperTypes, SingleProductTileActionTypes, ProductComparisonActionTypes, MonetateActionTypes, WishListActionTypes, } from '../../../enums/ActionEnums';
import { productActions } from '../../product/actions/ProductActions';
import { ProductRecentlyViewedActions } from '../../productRecentlyViewed/actions/ProductRecentlyViewedActions.creators';
import { ProductGroupFredhopperActions } from '../../productGroupFredhopper/actions/ProductGroupFredhopper.creators';
import { productGroupActions } from '../../productGroup/actions/ProductGroupActions.creators';
import { productComparisonActions } from '../../compare-page/actions/ProductComparison.creators';
import { singleProductTileActions } from '../../single-product-tile/actions/SingleProductTileActions.creators';
import { DELAY } from '../../../constants/GeneralConstants';
import { monetateActions } from '../../monetate/actions/MonetateActions.creators';
import { wishListActions } from '../../wishList/actions/WishListActions.creators';
import { isNotifyMeEnabled } from '../../product/reducers/ProductReducer';
import LocalStorageUtil from '../../../util/LocalStorageUtil';
import { SELECTED_STORE_STORAGE_KEY } from '../../../constants/StorageKeysConstants';
export function* getDeliveryPromiseSaga() {
    yield takeLatest(ProductActionTypes.SET_COLOR, getDeliveryPromiseByColor);
    yield takeLatest(ProductActionTypes.SELECT_SIZE, getDeliveryPromiseBySku);
    yield takeEvery(ProductRecentlyViewedActionTypes.GET_DELIVERY_PROMISE, getExtensiveTileProductDeliveryPromisesSaga);
    yield takeEvery(ProductGroupActionTypes.GET_DELIVERY_PROMISE, getExtensiveTileProductDeliveryPromisesSaga);
    yield takeEvery(ProductGroupFredhopperTypes.GET_DELIVERY_PROMISE, getExtensiveTileProductDeliveryPromisesSaga);
    yield takeEvery(ProductComparisonActionTypes.GET_DELIVERY_PROMISE, getExtensiveTileProductDeliveryPromisesSaga);
    yield takeEvery(SingleProductTileActionTypes.GET_DELIVERY_PROMISE, getExtensiveTileProductDeliveryPromisesSaga);
    yield takeEvery(ProductActionTypes.GET_DELIVERY_PROMISE, getDeliveryPromise);
    yield takeEvery(ProductActionTypes.GET_DELIVERY_PROMISE_EXTENDED, getDeliveryPromiseExtended);
    yield takeEvery(ProductActionTypes.GET_PRODUCT_CARE_DELIVERY_PROMISE, getExtensiveTileProductDeliveryPromisesSaga);
    yield takeEvery(MonetateActionTypes.GET_DELIVERY_PROMISE, getExtensiveTileProductDeliveryPromisesSaga);
    yield takeEvery(WishListActionTypes.LISTER_GET_DELIVERY_PROMISE, getExtensiveTileProductDeliveryPromisesSaga);
}
export const getProductId = (state) => state.product.productId;
export const getSku = (state) => state.product.selectedSku;
export const getSelectedStoreId = (state) => state.basket.clickAndCollectStoreId;
export const getPdpVersion = (state) => state.product.pdpVersion;
export const getNextSizes = (state, selectedColorId) => {
    const productColor = (state.product.productColorVariations || []).find((productColorVariation) => productColorVariation.colorId === selectedColorId);
    if (!isNullOrUndefined(productColor)) {
        return productColor === null || productColor === void 0 ? void 0 : productColor.sizes.filter((size) => size.active);
    }
    return null;
};
export function* getDeliveryPromiseExtended() {
    const productId = yield select(getProductId);
    const sku = yield select(getSku);
    const selectedStoreId = yield select(getSelectedStoreId);
    const { servicesEndpoint, authenticationConfig } = yield getContext('aemConfiguration');
    const selectedStoreFromLocalStorage = LocalStorageUtil.getJsonItem(SELECTED_STORE_STORAGE_KEY);
    yield fork(getDeliveryPromiseExtendedFromRemote, servicesEndpoint, authenticationConfig, productId, sku, selectedStoreFromLocalStorage ? Number(selectedStoreFromLocalStorage.storeId) : selectedStoreId);
}
export function* getDeliveryPromiseBySku(action) {
    if (action.payload.isSoldOut || action.payload.isDisabled || !action.payload.sku) {
        return;
    }
    const skuId = action.payload.sku;
    const { servicesEndpoint, authenticationConfig } = yield getContext('aemConfiguration');
    const productId = yield select(getProductId);
    yield fork(getDeliveryPromiseFromRemote, servicesEndpoint, skuId, productId, authenticationConfig);
}
export function* getDeliveryPromiseExtendedFromRemote(servicesEndpoint, authenticationConfig, productId, skuId, selectedStoreId) {
    try {
        const deliveryPromiseExtended = yield call(deliveryPromiseApi.getDeliveryPromiseExtended, servicesEndpoint, authenticationConfig, productId, skuId, selectedStoreId);
        yield put(productActions.createSetDeliveryPromiseExtended(deliveryPromiseExtended));
    }
    catch (_a) { }
}
export function* getDeliveryPromiseFromRemote(servicesEndpoint, skuId, productId, authenticationConfig, 
// eslint-disable-next-line @typescript-eslint/no-explicit-any
actionCreator, colourId, productGroupId) {
    try {
        const deliveryPromise = yield call(deliveryPromiseApi.getDeliveryPromise, servicesEndpoint, skuId, productId, authenticationConfig);
        if (actionCreator) {
            yield delay(DELAY.DELAY_500);
            yield put(actionCreator({ productId, deliveryPromise, colourId: Number(colourId), productGroupId }));
        }
        else {
            yield put(productActions.createSetDeliveryPromise(deliveryPromise));
        }
    }
    catch (_a) { }
}
export function* getDeliveryPromise() {
    const productId = yield select(getProductId);
    const sku = yield select(getSku);
    const { servicesEndpoint, authenticationConfig } = yield getContext('aemConfiguration');
    yield fork(getDeliveryPromiseFromRemote, servicesEndpoint, sku, productId, authenticationConfig);
}
export function* getDeliveryPromiseByColor(action) {
    const sizes = yield select(getNextSizes, action.payload);
    const pdpVersion = yield select(getPdpVersion);
    const activeSizes = sizes === null || sizes === void 0 ? void 0 : sizes.filter((size) => isNotifyMeEnabled(pdpVersion)
        ? (size.active && size.availability > 0) ||
            (size.active && size.availability <= 0 && size.historicAvailable && !size.storeSourceExcluded)
        : size.active && size.availability > 0);
    if ((activeSizes === null || activeSizes === void 0 ? void 0 : activeSizes.length) === 1) {
        const skuId = activeSizes[0].sku;
        const { servicesEndpoint, authenticationConfig } = yield getContext('aemConfiguration');
        const productId = yield select(getProductId);
        yield fork(getDeliveryPromiseFromRemote, servicesEndpoint, skuId, productId, authenticationConfig);
    }
}
export function* getExtensiveTileProductDeliveryPromisesSaga(action) {
    const actionCreatorsMap = {
        [ProductRecentlyViewedActionTypes.GET_DELIVERY_PROMISE]: ProductRecentlyViewedActions.setDeliveryPromise,
        [ProductGroupFredhopperTypes.GET_DELIVERY_PROMISE]: ProductGroupFredhopperActions.setDeliveryPromise,
        [ProductGroupActionTypes.GET_DELIVERY_PROMISE]: productGroupActions.setDeliveryPromise,
        [ProductComparisonActionTypes.GET_DELIVERY_PROMISE]: productComparisonActions.setDeliveryPromise,
        [SingleProductTileActionTypes.GET_DELIVERY_PROMISE]: singleProductTileActions.setDeliveryPromise,
        [ProductActionTypes.GET_PRODUCT_CARE_DELIVERY_PROMISE]: productActions.setProductCareDeliveryPromise,
        [MonetateActionTypes.GET_DELIVERY_PROMISE]: monetateActions.setDeliveryPromise,
        [WishListActionTypes.LISTER_GET_DELIVERY_PROMISE]: wishListActions.setDeliveryPromise,
    };
    const actionCreator = actionCreatorsMap[action.type];
    try {
        const { skuId, productId, colourId, productGroupId } = action.payload;
        const { servicesEndpoint, authenticationConfig } = yield getContext('aemConfiguration');
        yield fork(getDeliveryPromiseFromRemote, servicesEndpoint, skuId, productId, authenticationConfig, actionCreator, colourId, productGroupId);
    }
    catch (_a) { }
}
export default function* deliveryPromisesSaga() {
    yield all([getDeliveryPromiseSaga()]);
}
